jQuery(function ($) {
	const DESKTOP_BREAK = 1024;
	const MOBILE_BREAK = 600;
	function bindSubMenus() {
		const isDesktop = window.innerWidth > DESKTOP_BREAK;

		// Unbind any old handlers    
		$('.fl-has-submenu')
			.off('mouseenter mouseleave')
			.find('> .fl-has-submenu-container > a').off('click');

		if (isDesktop) {
			// desktop hover
			$('.fl-has-submenu')
				.on('click', function () {
					const $this = $(this);
					const isOpen = $this.hasClass('is-open');

					// Close all other matching elements
					$('.fl-has-submenu').removeClass('is-open')
						.find('> .fl-has-submenu-container > a').removeClass('is-open');

					// Then toggle the clicked one
					$this.toggleClass('is-open', !isOpen)
						.find('> .fl-has-submenu-container > a').toggleClass('is-open', !isOpen);
				});
		} else {
			function addParentLinks() {
				const w = window.innerWidth;

				// 1) always clean up old clones first
				$('.menu-item-parent-link').remove();

				// 2) only run on “tablet” widths: >600 && ≤1024
				if (w > MOBILE_BREAK && w <= DESKTOP_BREAK) {
					$('.fl-has-submenu').each(function () {
						const $li = $(this);
						const $link = $li.find('> .fl-has-submenu-container > a').first();
					});
				}


			}

			// init + rebind on resize
			addParentLinks();
			$(window).on('resize', addParentLinks);

			// tablet/mobile click
			$('.fl-has-submenu > .fl-has-submenu-container > a')
				.on('click', function (e) {
					e.preventDefault();

					const $item = $(this).closest('.fl-has-submenu');
					const $submenu = $item.children('ul.sub-menu');
					const opening = !$item.hasClass('is-open');
					// 1) Close all siblings and hide _their_ submenus
					$('.fl-has-submenu').not($item)
						.removeClass('is-open')
						.find('> .fl-has-submenu-container > a').removeClass('is-open')
						.end()                              // back to the .fl-has-submenu

					// 2) Toggle this one’s classes
					$item.toggleClass('is-open', opening)
						.find('> .fl-has-submenu-container > a')
						.toggleClass('is-open', opening)
				});

		}
	}
	$('.hamburger').on('click', function () {
		$('.gradientbg').toggleClass('menu-in', !$(this).hasClass('fl-active'));
	});
	bindSubMenus();
	$('#menu-search').on('click', function () {
		$(this).find('.fl-search-form-input-wrap').toggleClass('on');
	});
	$(window).on('resize', bindSubMenus);
});
